import {Store} from 'locallyjs';

export type LocallyJs = {
	set: (key: string, value: any) => void;
	get: (key: string) => any;
	remove: (key: string) => void;
	clear: () => void;
	keys: () => string[];
};

/**
 * Local storage instance.
 * @see https://www.npmjs.com/package/locallyjs
 * @example
 * localStore.set('foo', 'bar');
 */
// @ts-ignore
export const localStore = new Store({
	// DAM-19220 - set to false
	compress: false,
}) as unknown as LocallyJs;

export default localStore;

import {setGlobal} from '../utils/setGlobal';
if (process.env.NODE_ENV !== 'production') {
	setGlobal({localStore});
}
